<template>
  <div>
    <div class="col-6 d-flex align-items-center justify-content-lg-start">
      <Button
        v-if="showBackButton && actionType === 'save' || 'add'"
        label="List page"
        size="md"
        icon="ArrowLeftIcon"
        show-icon
        class="mb-1"
        @click="backNavigationAction"
      />
    </div>
    <form-wizard
      ref="loanProduct"
      :title="null"
      :subtitle="null"
      layout="vertical"
      back-button-text="Previous"
      class="wizard-vertical mb-3"
    >

      <!-- General Info tab -->
      <tab-content
        title="General"
        :before-change="validateGeneral"
      >
        <validation-observer ref="generalRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  General Information
                </h5>
              </b-col>
              <b-col md="6">
                <InputField
                  id="name-of-product"
                  v-model="loanProductFormData.name"
                  label=" Name of Product"
                  placeholder="Enter  name of product"
                  type="text"
                  error-name="Name of Product"
                  :rules="validationRules"
                  :readonly="isReadonly"
                  onpaste="return false;"
                  :is-allow-special-characters="false"
                />
              </b-col>
              <!-- Product Code -->
              <b-col md="6">
                <InputField
                  id="product-code"
                  v-model.number="loanProductFormData.code"
                  label="Product Code"
                  placeholder="Enter product code"
                  type="number"
                  error-name="Product Code"
                  :rules="isReadonly ? '' : 'required|integer|length:3'"
                  :readonly="isEditProductCode"
                />
              </b-col>
              <!-- Product Code -->

              <!--  Product Category -->
              <b-col md="6">
                <SelectField
                  id="product-category"
                  v-model="loanProductFormData.category"
                  label="Product Category"
                  :options="productCategoryOptions"
                  placeholder="Select"
                  error-name="Product Category"
                  :rules="validationRules"
                  :reduce="option => option.value"
                  item="label"
                  :set-selected="getPrincipalDueAndUnpaid"
                  :readonly="isReadonly"
                />
              </b-col>
              <!--  Product Category -->

              <!--  Currency -->
              <b-col md="6">
                <SelectField
                  id="currency-code"
                  v-model="loanProductFormData.currencyCode"
                  :reduce="option => option"
                  label="Currency"
                  :options="currencyCodeOptions"
                  placeholder="Select"
                  :error-name="actionType === 'add' ? 'Currency' : ''"
                  :rules="actionType === 'add' ? 'required' : ''"
                  item="label"
                  :readonly="isEditProductCode"
                />
              </b-col>
              <!--  Currency -->

            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Loan tab -->
      <tab-content
        title=" Loan Size"
        :before-change="validateLoanSize"
      >
        <validation-observer ref="loanSizeRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Loan Size Information
                </h5>
              </b-col>
              <b-col md="6">
                <SelectField
                  id="limit"
                  v-model="loanProductFormData.loanSize"
                  label="Limit"
                  :options="limitOptions"
                  :reduce="option => option.value"
                  placeholder="Select limit"
                  error-name="Limit"
                  :rules="validationRules"
                  item="label"
                  :set-selected="setLoanSizeAmount"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col
                v-if="isLoanSizeAmount"
                md="12"
              >
                <ValidationObserver>
                  <b-row>
                    <b-col md="6">
                      <InputNumberField
                        id="minimum"
                        v-model="loanProductFormData.minimumLoanAmount"
                        label="Minimum"
                        placeholder="Enter minimum"
                        error-name="Minimum"
                        :rules="isReadonly ? '' : 'required|integer|amount:@maxFee|positive'"
                        :readonly="isReadonly"
                      />
                    </b-col>

                    <b-col md="6">
                      <InputNumberField
                        id="maximum"
                        v-model="loanProductFormData.maximumLoanAmount"
                        label="Maximum"
                        placeholder="Enter maximum"
                        vid="maxFee"
                        error-name="Maximum"
                        :rules="isReadonly ? '' : 'required|integer|positive'"
                        :readonly="isReadonly"
                      />
                    </b-col>
                  </b-row>
                </ValidationObserver>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Security Deposit Requirement
                </h5>
              </b-col>

              <b-col md="6">
                <SwitchButton
                  v-model="loanProductFormData.applySecurityDeposit"
                  label="Hold Fund for Security Deposit"
                  name="security-deposit-requirement"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row v-if="setSecurityDeposit(loanProductFormData.applySecurityDeposit)">
              <b-col md="6">
                <SelectField
                  id="security-deposit-type"
                  v-model="loanProductFormData.securityDepositType"
                  label="Security Deposit Type"
                  :reduce="option => option.value"
                  :options="securityDepositTypeOptions"
                  placeholder="Select"
                  error-name="Security Deposit Type"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                  :set-selected="setAmountValidation"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="amount-percentage"
                  v-model.number="loanProductFormData.securityDepositCharge"
                  :label="isPercentageOrAmountLabel"
                  :placeholder="placeholderLabel"
                  type="number"
                  :error-name="isPercentageOrAmountLabel"
                  :rules="isPercentageOrAmount"
                  :readonly="isReadonly"
                />
              </b-col>

              <!-- <b-col md="4">
                <SwitchButton
                  v-model="loanProductFormData.holdFundSecurityDeposit"
                  label="Hold Fund for Security Deposit"
                  name="hold-fund-for-security-deposit"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col> -->
            </b-row>
          </b-form>

        </validation-observer>
      </tab-content>

      <!-- Tenure Information -->
      <tab-content
        title="Tenure/Principal"
        :before-change="validateTenure"
      >
        <validation-observer ref="tenureRules">
          <b-form>
            <!-- <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Tenure Information
                </h5>
              </b-col>
              <b-col md="6">
                <InputField
                  id="grace-period"
                  v-model.number="loanProductFormData.gracePeriod"
                  label="Grace Period (Days)"
                  placeholder="Enter grace period"
                  type="number"
                  error-name="Grace Period"
                  rules="required|integer|positive"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="tenure"
                  v-model.number="loanProductFormData.tenure"
                  label="Tenure (Days)"
                  placeholder="Enter tenure"
                  type="number"
                  error-name="Tenure"
                  rules="required|integer|positive"
                  :readonly="isReadonly"
                />
              </b-col>

            </b-row> -->

            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Principal Repayment Information
                </h5>
              </b-col>
              <b-col md="6">
                <SelectField
                  id="repayment-type"
                  v-model="loanProductFormData.principalRepaymentType"
                  label="Repayment Type"
                  :reduce="option => option.value"
                  :options="repaymentTypeOptions"
                  placeholder="Select"
                  error-name="Repayment Type"
                  :rules="validationRules"
                  item="label"
                  :set-selected="setRepaymentType"
                  :readonly="isReadonly"
                />
              </b-col>

            </b-row>

            <b-row>
              <b-col md="4">
                <InputField
                  id="principal-to-be-repaid"
                  v-model.number="loanProductFormData.principalToBeRepaidEvery"
                  label="Principal To Be Repaid Every"
                  type="number"
                  error-name="Principal To Be Repaid Every"
                  :rules="isReadonly ? '' : 'required|integer|positive'"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="4">
                <SelectField
                  id="frequency"
                  v-model="loanProductFormData.principalFrequency"
                  label="Frequency"
                  :reduce="option => option.value"
                  :options="frequencyOptions"
                  placeholder="Select"
                  error-name="Frequency"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="principal-installment"
                  v-model.number="loanProductFormData.principalInstallment"
                  label="Over"
                  type="number"
                  error-name="Principal Installment"
                  :rules="isReadonly ? '' : 'required|integer|positive'"
                  :readonly="isReadonly"
                  text="Installments"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Interest Repayment -->
      <tab-content
        title="Profit Repayment"
        :before-change="validateInterest"
      >
        <validation-observer ref="interestRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Profit Repayment
                </h5>
              </b-col>
              <b-col
                v-if="actionType !=='view'"
                md="6"
              >
                <SelectField
                  id="applicable-interest"
                  v-model="loanProductFormData.interestCode"
                  label="Select Applicable Profit"
                  :reduce="option => option.value"
                  :options="interestApplicationOptions"
                  placeholder="Select"
                  error-name="Select Applicable Profit"
                  rules="required"
                  item="label"
                  :set-selected="setApplicableInterest"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col
                v-else
                md="6"
              >
                <SelectField
                  id="applicable-interest"
                  v-model="loanProductFormData.interestCode"
                  label="Select Applicable Profit"
                  :reduce="option => option.value"
                  :options="interestApplicationOptions"
                  placeholder="Select"
                  item="label"
                  :set-selected="setApplicableInterest"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col>
                <InputField
                  id="applicable-interest-rate"
                  v-model.number="loanProductFormData.interestRate"
                  label="Applicable Profit Rate"
                  type="number"
                  rules="custom-maxValue:200|positive"
                  readonly
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="repayment-type"
                  v-model="loanProductFormData.interestRepaymentType"
                  label="Repayment Type"
                  :reduce="option => option.value"
                  :options="repaymentTypeOptions"
                  placeholder="Select"
                  error-name="Repayment Type"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <InputField
                  id="interest-to-be-repaid"
                  v-model.number="loanProductFormData.interestToBeRepaidEvery"
                  label="Profit To Be Repaid Every"
                  type="number"
                  error-name="Profit To Be Repaid Every"
                  :rules="isReadonly ? '' : 'required|integer|positive'"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="4">
                <SelectField
                  id="frequency"
                  v-model="loanProductFormData.interestFrequency"
                  label="Frequency"
                  :reduce="option => option.value"
                  :options="frequencyOptions"
                  placeholder="Select"
                  error-name="Frequency"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="4">
                <InputField
                  id="interest-installment"
                  v-model.number="loanProductFormData.interestInstallment"
                  label="Over"
                  type="number"
                  error-name="Profit Installment"
                  :rules="isReadonly ? '' : 'required|integer|positive'"
                  :readonly="isReadonly"
                  text="Installments"
                />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">
                <SelectField
                  id="interest-accrual-mode"
                  v-model="loanProductFormData.interestAccrualMode"
                  label="Profit Accrual Mode"
                  :reduce="option => option.value"
                  :options="interestAccrualOptions"
                  placeholder="Select"
                  error-name="Profit Accrual Mode"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6">
                <SwitchButton
                  v-model="loanProductFormData.applyDefaultingLoanInterest"
                  label="Apply Default Loan Profit"
                  name="apply-loan-fees"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
              <!-- fjffjfjjffjfjjf -->
              <b-col md="6">
                <InputField
                  id="grace-period-default-loan-interest-charges"
                  v-model.number="loanProductFormData.gracePeriodToStartDefaultInDays"
                  label="Grace Period To Start Default Loan Profit Charges"
                  placeholder="Enter grace period to start default loan profit charges"
                  type="number"
                  error-name="Grace Period To Start Default Loan Profit Charges"
                  :rules="isReadonly ? '' : 'required|integer'"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="unpaid-default-loan-interest-account"
                  v-model="loanProductFormData.unpaidDefaultLoanInterestAccount"
                  label="Unpaid Default Loan Profit Charge Account"
                  :options="unpaidLoanPenaltyOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Unpaid Default Loan Profit Charge Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="suspended-loan-interest-account"
                  v-model="loanProductFormData.suspendedDefaultLoanInterestAccount"
                  label="Suspended Default Loan Profit Charge Account"
                  :options="suspendedLoanPenaltyOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Suspended Default Loan Profit Charge Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="default-interes-charge-account"
                  v-model="loanProductFormData.defaultLoanInterestIncomeAccount"
                  label="Default Loan Profit Charge Account"
                  :reduce="option => option.value"
                  :options="penaltyIncomeOptions"
                  placeholder="Select"
                  error-name="Default Loan Profit Charge Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row v-if="setApplyDefaultingLoan(loanProductFormData.applyDefaultingLoanInterest)">
              <b-col md="6">
                <SelectField
                  id="default-loan-interest"
                  v-model="loanProductFormData.defaultingLoanInterestChargeDuration"
                  label="Default Loan Profit Charge Duration"
                  :reduce="option => option.value"
                  :options="penaltyChargeOptions"
                  placeholder="Select"
                  error-name="Default Loan Profit Charge Duration"
                  :rules="validationRules"
                  item="label"
                  :set-selected="setDefaultLoan"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <InputField
                  id="defaulting-loan-interest-rate"
                  v-model.number="loanProductFormData.defaultingInterestPercentage"
                  label="Defaulting Loan Profit Rate"
                  placeholder="Enter defaulting loan profit rate"
                  type="text"
                  error-name="Defaulting Loan Profit Rate"
                  :rules="isReadonly ? '' : 'required|upTo4Decimal|max-value:100|positive'"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col
                v-if="isDiscontinueDefault"
                md="6"
              >
                <InputField
                  id="discontinue-default-loan"
                  v-model.number="loanProductFormData.discontinueDefaultLoanInterestChargeInDays"
                  label="Discontinue Default Loan Profit Charge (In Days)"
                  placeholder="Enter discontinue default loan profit charge"
                  type="text"
                  error-name="Discontinue Default Loan Profit Charge"
                  :rules="isReadonly ? '' : 'required|positive|integer'"
                  :readonly="isReadonly"
                  @input="setDefaultMessage"
                />
                <small>{{ message }}</small>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!-- Reporting GLs -->
      <tab-content
        title="Reportings"
        :before-change="validateReporting"
      >
        <validation-observer ref="reportingRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Reporting GLs Accounts
                </h5>
              </b-col>

              <b-col md="6">
                <SelectField
                  id="principal-due-unpaid"
                  v-model="loanProductFormData.principalDueAndUnpaidAccountNumber"
                  label="Principal Due and Unpaid"
                  :reduce="option => option.value"
                  :options="principalDueAndUnpaidOptions"
                  placeholder="Select"
                  error-name="Principal Due and Unpaid"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-receivable"
                  v-model="loanProductFormData.interestReceivableAccountNumber"
                  label="Profit Receivable"
                  :options="interestReceivableOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name="Profit Receivable"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-due-unpaid"
                  v-model="loanProductFormData.interestDueAndUnpaidAccountNumber"
                  label="Profit Due and Unpaid"
                  :options="interestDueAndUnpaidOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name="Profit Due and Unpaid"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-suspended"
                  v-model="loanProductFormData.interestSuspenseAccountNumber"
                  label="Profit Suspended"
                  :options="interestSuspendedOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Profit Suspended"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="interest-income"
                  v-model="loanProductFormData.interestIncomeAccountNumber"
                  label="Profit Income"
                  :options="interestIncomeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  :rules="validationRules"
                  error-name="Profit Income"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>

            <b-row class="mt-3">
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Provision Reporting GLs
                </h5>
              </b-col>
              <b-col md="6">
                <SelectField
                  id="specific-loan-loss-account"
                  v-model="loanProductFormData.specificLoanLossAccountNumber"
                  label="Specific Loan Loss Account"
                  :options="specificLoanLossAccountOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  :rules="validationRules"
                  error-name="Specific Loan Loss Account"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="general-loan-loss-account"
                  v-model="loanProductFormData.generalLoanLossAccountNumber"
                  label="General Loan Loss Account"
                  :options="generalLoanLossAccountOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="General Loan Loss Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!--Loan Fee -->
      <tab-content
        title="Loan Fee"
        :before-change="validateLoanFee"
      >
        <validation-observer ref="loanFeeRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Loan Fee
                </h5>
              </b-col>
              <b-col md="4">
                <SwitchButton
                  v-model="loanProductFormData.applyLoanFees"
                  label="Apply Loan Fees"
                  name="apply-loan-fees"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row
              v-if="setLoanFee(loanProductFormData.applyLoanFees)"
              class="align-items-center"
            >
              <b-col md="6">
                <SelectField
                  id="loan-fee"
                  v-model="loanProductFormData.productLoanFees"
                  label="Loan Fee"
                  :options="loanFeeOptions"
                  placeholder="Select loan fee"
                  :reduce="option => option.value"
                  error-name="Loan Fee"
                  :rules="validationRules"
                  item="label"
                  multiple
                  :readonly="isReadonly"
                  class="select-fee"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="unpaid-loan-fee-account"
                  v-model="loanProductFormData.unpaidLoanFeeAccountNumber"
                  label="Unpaid Loan Fee Account"
                  :options="unpaidloanFeeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Unpaid Loan Fee Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="suspended-loan-fee-account"
                  v-model="loanProductFormData.suspendedLoanFeeAccountNumber"
                  label="Suspended Loan Fee Account"
                  :options="suspendedloanFeeOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Suspended Loan Fee Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!--Penalty -->
      <tab-content
        title="Penalty"
        :before-change="validatePenalty"
      >
        <validation-observer ref="penaltyRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Penalty Information
                </h5>
              </b-col>
              <b-col md="4">
                <SwitchButton
                  v-model="loanProductFormData.applyPenalty"
                  label="Apply Penalty"
                  name="apply-penalty"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>

            <b-row
              v-if="setPenalty(loanProductFormData.applyPenalty)"
              class="align-items-center"
            >
              <b-col md="6">
                <SelectField
                  id="penalty"
                  v-model="loanProductFormData.penaltyCode"
                  label="Penalty"
                  :options="penaltyOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Penalty"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="unpaid-loan-penalty-account"
                  v-model="loanProductFormData.unpaidLoanPenaltyAccountNumber"
                  label="Unpaid Loan Penalty Account"
                  :options="unpaidLoanPenaltyOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Unpaid Loan Penalty Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col md="6">
                <SelectField
                  id="suspended-loan-penalty-account"
                  v-model="loanProductFormData.suspendedLoanPenaltyAccountNumber"
                  label="Suspended Loan Penalty Account"
                  :options="suspendedLoanPenaltyOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Suspended Loan Penalty Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="penalty-income-account"
                  v-model="loanProductFormData.penaltyIncomeAccountNumber"
                  label="Penalty Income Account"
                  :reduce="option => option.value"
                  :options="penaltyIncomeOptions"
                  placeholder="Select"
                  error-name="Penalty Income Account"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="penalty-charge-duration"
                  v-model="loanProductFormData.penaltyChargeDuration"
                  label="Penalty Charge Duration"
                  :options="penaltyChargeOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name="penalty-charge-duration"
                  :rules="validationRules"
                  item="label"
                  :set-selected="setDiscontinuePenalty"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="grace-period"
                  v-model.number="loanProductFormData.penaltyGracePeriod"
                  label="Grace Period To Start Penalty Charge"
                  placeholder="Enter grace period to start  penalty charge"
                  type="number"
                  error-name="Grace Period To Start Penalty Charge"
                  :rules="isReadonly ? '' : 'required|integer'"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col
                v-if="isDiscontinuePenalty"
                md="6"
              >
                <InputField
                  id="discontinue-penalty"
                  v-model.number="loanProductFormData.periodToDiscontinuePenalty"
                  label="Discontinue Penalty Charge (In Days)"
                  placeholder="Enter discontinue penalty charge"
                  type="number"
                  error-name="Discontinue Penalty Charge"
                  :rules="isReadonly ? '' : 'required|integer|positive'"
                  :readonly="isReadonly"
                  @input="setDiscontinuePenaltyMessage"
                />
                <small>{{ penaltyMessage }}</small>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <!--Others -->
      <tab-content
        title="Other Configuration"
        :before-change="validateOtherConfigurations"
      >
        <validation-observer ref="otherConfigurationRules">
          <b-form>
            <b-row>
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0">
                  Other Loan Configuration
                </h5>
              </b-col>

              <b-col md="6">
                <SwitchButton
                  v-model="loanProductFormData.allowMultipleActiveLoansPerAccount"
                  label="Allow Multiple Active Loans per Account"
                  name="allow-multiple-loans"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <br>
            <b-row>
              <b-col md="6">
                <SelectField
                  id="repayment-option-for-daily-weekly"
                  v-model="loanProductFormData.repaymentOptionForDailyAndWeeklyHoliday"
                  label="Repayment Option for Daily & Weekly Loan Frequency that fall Due on Weekend/Public holiday"
                  :options="repaymentOptionForDailyAndWeeklyHolidayOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Repayment Option for Daily & Weekly Loan Frequency that fall Due on Weekend/Public holiday"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="repayment-frequency-holiday"
                  v-model="loanProductFormData.repaymentOptionForOtherFrequencyHoliday"
                  label="Repayment Option for Other Loan Frequency that fall Due on Weekend/Public holiday"
                  :options="repaymentOptionForOtherFrequencyHolidayOptions"
                  placeholder="Select"
                  :reduce="option => option.value"
                  error-name="Repayment Option for Other Loan Frequency that fall Due on Weekend/Public holiday"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row
              class="align-items-center"
            >
              <b-col
                cols="12"
                class="mb-2"
              >
                <h5 class="mb-0 mt-3">
                  Moratorium
                </h5>
              </b-col>
              <b-col md="6">
                <SelectField
                  id="alow-moratorium-loan"
                  v-model="loanProductFormData.allowMoratorium"
                  label="Allow Moratorium On Loan Repayment"
                  :reduce="option => option.value"
                  :options="moratoriumTypeOptions"
                  placeholder="Select"
                  error-name="Allow Moratorium On Loan Repayment"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                  :set-selected="setMoratorium"
                />
              </b-col>
            </b-row>

            <b-row v-if="isAllowMoratorium">
              <b-col md="6">
                <SelectField
                  id="moratorium-effect"
                  v-model="loanProductFormData.moratoriumEffect"
                  label="Moratorium Effect On Loan Duration"
                  :options="moratoriumEffectOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name=" Moratorium Effect On Loan Duration"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <InputField
                  id="moratorium-duration"
                  v-model.number="loanProductFormData.moratoriumDuration"
                  label="Moratorium Duration"
                  placeholder="Enter moratorium duration"
                  type="number"
                  error-name="Moratorium Duration"
                  :rules="isReadonly ? '' : 'required|integer|positive'"
                  :readonly="isReadonly"
                />
              </b-col>

              <b-col md="6">
                <SelectField
                  id="frequency"
                  v-model="loanProductFormData.moratoriumFrequency"
                  label="Frequency"
                  :options="moratoriumFrequencyOptions"
                  :reduce="option => option.value"
                  placeholder="Select"
                  error-name=" Frequency"
                  :rules="validationRules"
                  item="label"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <SwitchButton
                  v-model="loanProductFormData.allowDisbursementsToGL"
                  label="Allow Disbursements To GL"
                  name="allow-disbursement"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <SwitchButton
                  v-model="loanProductFormData.enableRepaymentTracker"
                  label="Enable Replayment Tracker"
                  name="enable-repayment-tracker"
                  class="mt-2"
                  :readonly="isReadonly"
                />
              </b-col>
              <b-col
                v-if="setRepaymentTracker(loanProductFormData.enableRepaymentTracker)"
                class="align-items-center"
                md="6"
              >
                <InputField
                  id="repayment-trackerInDays"
                  v-model.number="loanProductFormData.repaymentTrackerInDays"
                  label="Repayment Tracker in Days"
                  placeholder="Enter Repayment Tracker in Days"
                  type="number"
                  error-name="Repayment Tracker in Days"
                  :rules="isReadonly ? '' : 'required|integer|positive'"
                  :readonly="isReadonly"
                />
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </tab-content>

      <template
        slot="finish"
      >
        <div class="wizard-footer-right">
          <Button
            label="Submit"
            :loading="isLoading"
            :disabled="isDisabled"
            size="lg"
            @click="handleSubmit"
          />
        </div>

      </template>
      <FullScreenSpinner :show="showSpinner" />
    </form-wizard>

  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BForm,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapActions } from 'vuex'
import { ValidationObserver } from 'vee-validate'
import { required, maxValue, positive } from '@validations'
import { toastAlert } from '@core/mixins/toast'
import { sweetAlert } from '@core/mixins/sweetAlert'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import InputField from '../../../../forms/InputField.vue'
import SelectField from '../../../../forms/SelectField.vue'
import SwitchButton from '../../../../components/switch/Switch.vue'
import {
  loanProductCategory,
  repaymentTypes,
  interestAccruals,
  periodPenalties,
  penaltyCharges,
  securityDeposits,
  securityDepositTypes,
  limits,
  repaymentOptionForDailyAndWeeklyHoliday,
  repaymentOptionForOtherFrequencyHoliday,
  moratoriumType,
  moratoriumEffect,
  repaidFrequencies,
} from '../../../../../helpers/data'
import InputNumberField from '../../../../forms/InputNumberField.vue'
import Button from '../../../../components/button/Button.vue'
import { accountPermissions } from '../../../../../helpers/permissions'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BForm,
    BCol,
    Button,
    FullScreenSpinner,
    SwitchButton,
    InputField,
    SelectField,
    InputNumberField,
    ValidationObserver,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  mixins: [toastAlert, sweetAlert],
  data() {
    return {
      required,
      maxValue,
      positive,
      isEditProductCode: false,
      isDisabled: false,
      isLoading: false,
      isAllowMoratorium: false,
      isReadonly: false,
      showSpinner: false,
      showBackButton: false,
      isPercentageOrAmount: 'required|positive',
      isPercentageOrAmountLabel: 'Amount',
      placeholderLabel: 'Enter amount',
      loanProductFormData: {
        code: null,
        name: '',
        category: '',
        tenure: '',
        interestReceivableAccountNumber: '',
        interestSuspenseAccountNumber: '',
        principalDueAndUnpaidAccountNumber: '',
        interestDueAndUnpaidAccountNumber: '',
        interestIncomeAccountNumber: '',
        interestAccrualMode: '',
        specificLoanLossAccountNumber: '',
        generalLoanLossAccountNumber: '',
        unpaidLoanFeeAccountNumber: '',
        suspendedLoanFeeAccountNumber: '',
        loanSize: '',
        minimumLoanAmount: null,
        maximumLoanAmount: null,
        applySecurityDeposit: false,
        holdFundSecurityDeposit: false,
        securityDepositType: '',
        securityDepositCharge: null,
        gracePeriod: null,
        principalRepaymentType: '',
        principalFrequency: '',
        principalToBeRepaidEvery: '',
        principalInstallment: '',
        interestRepaymentType: '',
        interestFrequency: '',
        interestToBeRepaidEvery: '',
        interestInstallment: '',
        defaultingInterestPercentage: null,
        applyLoanFees: false,
        productLoanFees: [],
        applyDefaultingLoanInterest: false,

        gracePeriodToStartDefaultInDays: null,
        unpaidDefaultLoanInterestAccount: '',
        suspendedDefaultLoanInterestAccount: '',
        defaultLoanInterestIncomeAccount: '',

        defaultingLoanInterestChargeDuration: '',
        discontinueDefaultLoanInterestChargeInDays: null,
        applyPenalty: false,
        penaltyCode: '',
        penaltyGracePeriod: null,
        penaltyChargeDuration: '',
        periodToDiscontinuePenalty: null,
        penaltyIncomeAccountNumber: '',
        unpaidLoanPenaltyAccountNumber: '',
        suspendedLoanPenaltyAccountNumber: '',
        allowMultipleActiveLoansPerAccount: false,
        allowMoratorium: '',
        moratoriumEffect: '',
        repaymentOptionForDailyAndWeeklyHoliday: '',
        repaymentOptionForOtherFrequencyHoliday: '',
        moratoriumDuration: 0,
        moratoriumFrequency: '',
        enableRepaymentTracker: false,
        repaymentTrackerInDays: '',
        allowDisbursementsToGL: false,
        currencyCode: null,
        interestCode: '',
        interestRate: 0,
      },
      actionType: 'add',
      productCategoryOptions: loanProductCategory,
      repaymentTypeOptions: repaymentTypes,
      frequencyOptions: repaidFrequencies,
      interestAccrualOptions: interestAccruals,
      periodPenaltyOptions: periodPenalties,
      penaltyChargeOptions: penaltyCharges,
      securityDepositOptions: securityDeposits,
      securityDepositTypeOptions: securityDepositTypes,
      limitOptions: limits,
      principalDueAndUnpaidOptions: [],
      interestReceivableOptions: [],
      interestDueAndUnpaidOptions: [],
      interestSuspendedOptions: [],
      interestIncomeOptions: [],
      specificLoanLossAccountOptions: [],
      generalLoanLossAccountOptions: [],
      loanFeeOptions: [],
      feeDetails: [],
      unpaidloanFeeOptions: [],
      suspendedloanFeeOptions: [],
      loanProduct: [
        { label: 'MicroLoan', id: 18 },
        { label: 'StaffLoan', id: 21 },
        { label: 'SmallAndMediumLoans', id: 20 },
        { label: 'OtherLoans', id: 19 },
        { label: 'HirePurchase', id: 22 },
        { label: 'OnlineLoan', id: 18 },
      ],
      message: '',
      penaltyMessage: '',
      isDiscontinueDefault: false,
      isDiscontinuePenalty: false,
      isInterestRepayment: false,
      isRepaymentType: false,
      penaltyOptions: [],
      suspendedLoanPenaltyOptions: [],
      unpaidLoanPenaltyOptions: [],
      penaltyIncomeOptions: [],
      repaymentOptionForDailyAndWeeklyHolidayOptions: repaymentOptionForDailyAndWeeklyHoliday,
      repaymentOptionForOtherFrequencyHolidayOptions: repaymentOptionForOtherFrequencyHoliday,
      moratoriumTypeOptions: moratoriumType,
      moratoriumEffectOptions: moratoriumEffect,
      moratoriumFrequencyOptions: repaidFrequencies,
      isLoanSizeAmount: false,
      permission: '',
      interestApplicationOptions: [],
      currencyCodeOptions: [],
    }
  },
  computed: {
    validationRules() {
      if (this.isReadonly) {
        return ''
      }
      return 'required'
    },

  },
  mounted() {
    const { type, currencyOptions } = this.$route.params
    this.actionType = type
    this.currencyCodeOptions = currencyOptions
    this.getPermission()
    this.getInterestReceivable()
    this.getInterestDueAndUnpaid()
    this.getInterestSuspended()
    this.getInterestIncome()
    this.getSpecificLoanLossAccount()
    this.getGeneralLoanLossAccount()
    this.getLoanFee()
    this.getUnpaidLoanFee()
    this.getSuspendedLoanFee()
    this.fetchPenalties()
    this.getSuspendedLoanPenalty()
    this.getUnpaidLoanPenalty()
    this.getPenaltyIncomeAccount()
    this.getLoanProductDetails()
    this.fetchInterestApplicable()
  },
  methods: {
    ...mapActions({
      getGLAccountsByAccountType: 'account/getGLAccountsByAccountTypeList',
      getGeneralLedger: 'account/getGeneralLedgerList',
      getLoanFees: 'account/getLoanFeeList',
      createLoanProduct: 'account/createLoanProductAction',
      updateLoanProduct: 'account/updateLoanProductAction',
      getLoanProduct: 'account/getProduct',
      getPenalties: 'account/getPenaltiesList',
      getIncomeGLByParentCategory: 'account/getIncomeGLByParentCategory',
      getInterestApplicable: 'account/getInterestList',
    }),
    getPermission() {
      if (this.actionType === 'save' || this.actionType === 'add') {
        this.permission = accountPermissions.CREATE_LOAN_PRODUCT_NIB
        return
      }
      if (this.actionType === 'edit') {
        this.permission = accountPermissions.MODIFY_LOAN_PRODUCT_NIB
        return
      }
      this.permission = accountPermissions.VIEW_LOAN_PRODUCT_NIB
    },
    setMoratorium(selectedValue) {
      if (selectedValue === 'False') {
        this.isAllowMoratorium = false
        this.loanProductFormData.moratoriumEffect = null
        this.loanProductFormData.moratoriumDuration = null
        this.loanProductFormData.moratoriumFrequency = null
      } else {
        this.isAllowMoratorium = true
      }
    },
    setAmountValidation(selectedValue) {
      if (selectedValue === 'PercentageOnLoanAmount') {
        this.isPercentageOrAmount = 'required|max-value:100|positive'
        this.isPercentageOrAmountLabel = 'Percentage'
        this.placeholderLabel = 'Enter percentage'
      } else {
        this.isPercentageOrAmount = 'required|positive'
        this.isPercentageOrAmountLabel = 'Amount'
        this.placeholderLabel = 'Enter amount'
      }
    },
    setDefaultMessage(value) {
      if (value) {
        this.message = `Discontinue default loan profit charge ${value} days after loan expiration.`
        return true
      }
      this.message = ''
      return false
    },
    setDiscontinuePenaltyMessage(value) {
      if (value) {
        this.penaltyMessage = `Discontinue penalty charge ${value} days after loan expiration.`
        return true
      }
      this.penaltyMessage = ''
      return false
    },
    setPenalty(value) {
      if (!value) {
        this.loanProductFormData.penaltyCode = null
        this.loanProductFormData.penaltyGracePeriod = null
        this.loanProductFormData.penaltyChargeDuration = null
        this.loanProductFormData.periodToDiscontinuePenalty = null
        this.loanProductFormData.penaltyIncomeAccountNumber = null
        return false
      }
      return true
    },
    setApplyDefaultingLoan(value) {
      if (!value) {
        this.loanProductFormData.defaultingLoanInterestChargeDuration = null
        this.loanProductFormData.defaultingInterestPercentage = null
        return false
      }
      return true
    },
    setSecurityDeposit(value) {
      if (!value) {
        this.loanProductFormData.securityDepositType = null
        this.loanProductFormData.securityDepositCharge = null
        this.loanProductFormData.holdFundSecurityDeposit = false
        return false
      }
      return true
    },
    setDefaultLoan(selectedValue) {
      if (selectedValue === 'Discontinuous') {
        this.isDiscontinueDefault = true
        return true
      }
      this.isDiscontinueDefault = false
      this.loanProductFormData.discontinueDefaultLoanInterestChargeInDays = null
      this.message = ''
      return false
    },
    setDiscontinuePenalty(selectedValue) {
      if (selectedValue === 'Discontinuous') {
        this.isDiscontinuePenalty = true
        return true
      }
      this.isDiscontinuePenalty = false
      this.loanProductFormData.periodToDiscontinuePenalty = null
      this.penaltyMessage = ''
      return false
    },
    setLoanFee(value) {
      if (!value) {
        this.loanProductFormData.productLoanFees = null
        this.loanProductFormData.unpaidLoanFeeAccountNumber = null
        this.loanProductFormData.suspendedLoanFeeAccountNumber = null
        return false
      }
      return true
    },
    setRepaymentTracker(value) {
      if (!value) {
        this.loanProductFormData.repaymentTrackerInDays = null
        return false
      }
      return true
    },
    setLoanSizeAmount(value) {
      if (value === 'Limited') {
        this.isLoanSizeAmount = true
        this.loanProductFormData.minimumLoanAmount = null
        this.loanProductFormData.maximumLoanAmount = null
        return false
      }
      this.isLoanSizeAmount = false
      return true
    },
    setRepaymentType(value) {
      if (value === 'Prorated') {
        this.isRepaymentType = true
        this.loanProductFormData.principalFrequency = null
        this.loanProductFormData.principalToBeRepaidEvery = null
        this.loanProductFormData.principalInstallment = null

        return false
      }
      this.isRepaymentType = false
      return true
    },
    setInterestRepayment(value) {
      if (value === 'Prorated') {
        this.isInterestRepayment = true
        this.loanProductFormData.interestFrequency = null
        this.loanProductFormData.interestToBeRepaidEvery = null
        this.loanProductFormData.interestInstallment = null
        return false
      }
      this.isInterestRepayment = false
      return true
    },
    async fetchInterestApplicable() {
      try {
        const response = await this.getInterestApplicable({
          search: { type: 'Debit' },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = response
        if (status === 200) {
          this.interestApplicationOptions = data.data.filter(dataItem => dataItem.status === 'Active').map(item => ({
            label: item.name,
            value: item.code,
          }))
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.isBusy = false
      }
    },
    async setApplicableInterest(selectedValue) {
      try {
        const response = await this.getInterestApplicable({
          search: { code: selectedValue },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = await response
        if (status === 200) {
          this.loanProductFormData.interestRate = data.data[0].rate
        }
      } catch (error) {
        this.toastAlert({ title: error })
      }
    },
    async getPrincipalDueAndUnpaid(selectedValue) {
      try {
        const loanProduct = this.loanProduct.find(item => item.label === selectedValue)
        this.loanProductFormData.principalDueAndUnpaidAccountNumber = ''
        const response = await this.getGLAccountsByAccountType({ accountType: loanProduct.id, permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.principalDueAndUnpaidOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getInterestReceivable() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 13, permission: this.permission })
        const { status, data } = await response

        if (status === 200) {
          this.interestReceivableOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getInterestDueAndUnpaid() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 11, permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.interestDueAndUnpaidOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getInterestSuspended() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 10, permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.interestSuspendedOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getInterestIncome() {
      try {
        const response = await this.getGeneralLedger({
          search: { accountCategoryCode: 40304000 },
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.interestIncomeOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getSpecificLoanLossAccount() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 23, permission: this.permission })
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.specificLoanLossAccountOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getGeneralLoanLossAccount() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 8, permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.generalLoanLossAccountOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getLoanFee() {
      try {
        const response = await this.getLoanFees({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.feeDetails = data.data
          this.loanFeeOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.amount}`, value: curr.code }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getUnpaidLoanFee() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 6, permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.unpaidloanFeeOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getSuspendedLoanFee() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 5, permission: this.permission })
        const { status, data } = await response
        if (status === 200) {
          this.suspendedloanFeeOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async fetchPenalties() {
      try {
        const response = await this.getPenalties({
          search: '',
          page: 0,
          limit: 0,
          permission: this.permission,
        })
        const { status, data } = await response
        if (status === 200 && data.data) {
          this.penaltyOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getSuspendedLoanPenalty() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 5, permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.suspendedLoanPenaltyOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getUnpaidLoanPenalty() {
      try {
        const response = await this.getGLAccountsByAccountType({ accountType: 17, permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.unpaidLoanPenaltyOptions = data.data.reduce((acc, curr) => [...acc, { label: `${curr.accountName} - ${curr.accountNumber}`, value: curr.accountNumber }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async getPenaltyIncomeAccount() {
      try {
        const response = await this.getIncomeGLByParentCategory({ permission: this.permission })
        const { status, data } = await response

        if (status === 200 && data.data) {
          this.penaltyIncomeOptions = data.data.filter(item => item.status === 'Active').reduce((acc, curr) => [...acc, { label: `${curr.name} - ${curr.code}`, value: curr.code.toString() }], [])
        }
      } catch (error) {
        this.toastAlert({ title: `${error}` })
      }
    },
    async handleSubmit() {
      const action = `${this.actionType === 'add' ? 'Save' : 'Modify'}`
      const isFormCompleted = await this.validateOtherConfigurations()
      if (isFormCompleted) {
        this.confirm(this.createLoanProductAction, { title: '', text: `Are you sure you want to ${action} this Loan Product?` })
      }
    },
    async createLoanProductAction() {
      const action = `${this.actionType === 'add' ? 'Save' : 'Modify'}`
      try {
        this.isLoading = true
        this.isDisabled = true

        const productLoanFees = this.loanProductFormData.productLoanFees !== null
          ? this.loanProductFormData.productLoanFees.map(item => {
            if (typeof item !== 'object') {
              return { loanFeeCode: item }
            }
            return { loanFeeCode: item.value }
          }) : []
        const formData = { ...this.loanProductFormData, productLoanFees }

        const response = this.actionType === 'add'
          ? await this.createLoanProduct(formData)
          : await this.updateLoanProduct(formData)

        const { status } = await response
        if (status === 200) {
          this.alertSuccess({ text: `Your request to ${action} Loan Product was successful` })
          this.$router.push({ name: 'loan-product-list-nib' })
        }
      } catch (error) {
        this.handleError(error)
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async getLoanProductDetails() {
      try {
        const { id, type } = this.$route.params
        if (id !== undefined) {
          this.showSpinner = true
          this.showBackButton = true
          this.actionType = type
          this.isReadonly = type !== 'edit'
          this.isDisabled = type !== 'edit'
          this.isEditProductCode = true
          this.$refs.loanProduct.activateAll()

          const response = await this.getLoanProduct({ id, permission: this.permission })
          const { data, status } = await response
          if (status === 200 && data.data) {
            this.getPrincipalDueAndUnpaid(data.data.category)
            this.setLoanSizeAmount(data.data.loanSize)
            this.setApplyDefaultingLoan(data.data.applyDefaultingLoanInterest)
            this.setRepaymentType(data.data.principalRepaymentType)
            this.setInterestRepayment(data.data.interestRepaymentType)
            this.setAmountValidation(data.data.securityDepositType)
            this.setDefaultLoan(data.data.defaultingLoanInterestChargeDuration)
            this.setDiscontinuePenalty(data.data.penaltyChargeDuration)
            this.setMoratorium(data.data.setMoratorium)
            let productLoanFees

            if (data.data.productLoanFees.length) {
              const feeCodes = data.data.productLoanFees.map(item => item.loanFeeCode)
              productLoanFees = this.feeDetails.filter(items => {
                if (feeCodes.includes(items.code)) {
                  return items
                }
                return false
              }).map(item => ({ label: item.name, value: item.code }))
            }
            this.setMoratorium(data.data.allowMoratorium)
            this.loanProductFormData = {
              id,
              code: data.data.code,
              name: data.data.name,
              category: data.data.category,
              tenure: data.data.tenure,
              interestReceivableAccountNumber: data.data.interestReceivableAccountNumber,
              interestSuspenseAccountNumber: data.data.interestSuspenseAccountNumber,
              principalDueAndUnpaidAccountNumber: data.data.principalDueAndUnpaidAccountNumber,
              interestDueAndUnpaidAccountNumber: data.data.interestDueAndUnpaidAccountNumber,
              interestIncomeAccountNumber: data.data.interestIncomeAccountNumber,
              specificLoanLossAccountNumber: data.data.specificLoanLossAccountNumber,
              generalLoanLossAccountNumber: data.data.generalLoanLossAccountNumber,
              unpaidLoanFeeAccountNumber: data.data.unpaidLoanFeeAccountNumber,
              suspendedLoanFeeAccountNumber: data.data.suspendedLoanFeeAccountNumber,
              interestAccrualMode: data.data.interestAccrualMode,
              loanSize: data.data.loanSize,
              minimumLoanAmount: data.data.minimumLoanAmount,
              maximumLoanAmount: data.data.maximumLoanAmount,
              applySecurityDeposit: data.data.applySecurityDeposit,
              holdFundSecurityDeposit: data.data.holdFundSecurityDeposit,
              securityDepositType: data.data.securityDepositType,
              securityDepositCharge: data.data.securityDepositCharge || '0',
              gracePeriod: data.data.gracePeriod,
              principalRepaymentType: data.data.principalRepaymentType,
              principalFrequency: data.data.principalFrequency,
              principalToBeRepaidEvery: data.data.principalToBeRepaidEvery,
              principalInstallment: data.data.principalInstallment,
              interestRepaymentType: data.data.interestRepaymentType,
              interestFrequency: data.data.interestFrequency,
              interestToBeRepaidEvery: data.data.interestToBeRepaidEvery || '0',
              interestInstallment: data.data.interestInstallment || '0',
              defaultingInterestPercentage: data.data.defaultingInterestPercentage,
              applyLoanFees: data.data.applyLoanFees,
              productLoanFees,
              applyDefaultingLoanInterest: data.data.applyDefaultingLoanInterest,
              gracePeriodToStartDefaultInDays: data.data.gracePeriodToStartDefaultInDays || '0',
              unpaidDefaultLoanInterestAccount: data.data.unpaidDefaultLoanInterestAccount,
              suspendedDefaultLoanInterestAccount: data.data.suspendedDefaultLoanInterestAccount,
              defaultLoanInterestIncomeAccount: data.data.defaultLoanInterestIncomeAccount,
              defaultingLoanInterestChargeDuration: data.data.defaultingLoanInterestChargeDuration,
              discontinueDefaultLoanInterestChargeInDays: data.data.discontinueDefaultLoanInterestChargeInDays,
              applyPenalty: data.data.applyPenalty,
              penaltyCode: data.data.penaltyCode,
              penaltyGracePeriod: data.data.penaltyGracePeriod || '0',
              penaltyChargeDuration: data.data.penaltyChargeDuration,
              periodToDiscontinuePenalty: data.data.periodToDiscontinuePenalty || '0',
              penaltyIncomeAccountNumber: data.data.penaltyIncomeAccountNumber,
              unpaidLoanPenaltyAccountNumber: data.data.unpaidLoanPenaltyAccountNumber,
              suspendedLoanPenaltyAccountNumber: data.data.suspendedLoanPenaltyAccountNumber,
              allowMultipleActiveLoansPerAccount: data.data.allowMultipleActiveLoansPerAccount,
              allowMoratorium: data.data.allowMoratorium,
              moratoriumEffect: data.data.moratoriumEffect,
              repaymentOptionForDailyAndWeeklyHoliday: data.data.repaymentOptionForDailyAndWeeklyHoliday,
              repaymentOptionForOtherFrequencyHoliday: data.data.repaymentOptionForOtherFrequencyHoliday,
              moratoriumDuration: data.data.moratoriumDuration || '0',
              moratoriumFrequency: data.data.moratoriumFrequency,
              enableRepaymentTracker: data.data.enableRepaymentTracker,
              repaymentTrackerInDays: data.data.repaymentTrackerInDays || '0',
              allowDisbursementsToGL: data.data.allowDisbursementsToGL,
              currencyCode: data.data?.currencyCode,
              interestCode: data.data?.interestCode,
              interestRate: data.data?.interestRate,
            }
            this.showSpinner = false
          }
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
    backNavigationAction() {
      this.showBackButton = true
      this.$router.push({
        name: 'loan-product-list-nib',
      })
    },

    // onChangeTab() {
    //   const dropDownSelect = document.querySelector('#loan-fee').querySelectorAll('.vs__selected')
    //   dropDownSelect.forEach(item => {
    //     item.classList.add('selected')
    //   })
    // },
    validateGeneral() {
      return new Promise((resolve, reject) => {
        this.$refs.generalRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateLoanSize() {
      return new Promise((resolve, reject) => {
        this.$refs.loanSizeRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateTenure() {
      return new Promise((resolve, reject) => {
        this.$refs.tenureRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateInterest() {
      return new Promise((resolve, reject) => {
        this.$refs.interestRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateReporting() {
      return new Promise((resolve, reject) => {
        this.$refs.reportingRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateLoanFee() {
      return new Promise((resolve, reject) => {
        this.$refs.loanFeeRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateOtherConfigurations() {
      return new Promise((resolve, reject) => {
        this.$refs.otherConfigurationRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validatePenalty() {
      return new Promise((resolve, reject) => {
        this.$refs.penaltyRules.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-wizard.scss';
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
